import { useQuickPostV3ModalStore } from "@circle-react/components/QuickPostV3/store";
import {
  useMdScreenMediaQuery,
  useSmScreenMediaQuery,
} from "@circle-react/hooks/useMediaQuery";
import { useIsMobile } from "@circleco/compass/hooks/useIsMobile";

export const useComposerLayout = () => {
  const isFullscreen = useQuickPostV3ModalStore(state => state.isFullscreen);
  const isMobile = useIsMobile();
  const isSmScreen = useSmScreenMediaQuery();
  const isMdScreen = useMdScreenMediaQuery();
  const isFullScreenLayout = isFullscreen || isSmScreen;

  return {
    isMobile,
    isMdScreen,
    isSmScreen,
    isFullScreenLayout,
    shouldInlineTopics: isFullScreenLayout && isMdScreen,
  };
};
